const sizeConfigs = {
  sidebar: {
    width: "300px",
    minWidth: '70px'
  }
};

export default sizeConfigs;